import HTTP from "@/_helpers/http";
import { MAMWALLET__API } from "@/_helpers/urls";
import { MAMWALLET__MUTATIONS } from "../mutation-types";
import { MAMWALLET__ACTIONS } from "../action-types";

// =====================
// STATE
// =====================
const state = {
  mamlists: [],
  isLoading: false,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1,
  },
};

// =====================
// GETTERS (optional)
// =====================
const getters = {};

// =====================
// MUTATIONS
// =====================
const mutations = {
    [MAMWALLET__MUTATIONS.MANAGERSWALLETINFO](state, payload) {
        state.mamlists = payload?.wallets || [];
        state.pagination = payload?.pagination || {
            total: 0,
            perPage: 10,
            currentPage: 1,
            lastPage: 1,
        };
    },


  SET_LOADING(state, status) {
    state.isLoading = status;
  },
};

// =====================
// ACTIONS
// =====================
const actions = {
  async [MAMWALLET__ACTIONS.MANAGERSWALLETINFO]({ commit }, parameter = {}) {
    try {
      commit("SET_LOADING", true);

      const {
        page = 1,
        limit = 10,
        search = "",
      } = parameter;

      const queryParams = new URLSearchParams({
        page: String(page),
        limit: String(limit),
        ...(search ? { search } : {}),
      }).toString();

      const response = await HTTP().get(
        `${MAMWALLET__API.MANAGERSWALLETINFO}${
          queryParams ? `?${queryParams}` : ""
        }`
      );

      /**
       * 🔥 IMPORTANT
       * Backend response shape:
       * {
       *   success: true,
       *   data: {
       *     mams: [],
       *     pagination: {}
       *   }
       * }
       */
      commit(
        MAMWALLET__MUTATIONS.MANAGERSWALLETINFO,
        response.data.data
      );
    } catch (error) {
      console.error("MANAGERSWALLETINFO error:", error);
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

// =====================
// EXPORT
// =====================
export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
